export default __webpack_public_path__ + "alberta-available.9876564609a8a6b9b18e.svg";